
import { defineComponent } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    props: {
        title: {
            type: String,
            default: 'Modal header',
        },
        confirmButtonText: {
            type: String,
            default: 'Подтвердить',
        },
        confirmButtonClass: {
            type: String,
            default: 'small primary',
        },
        cancelButtonText: {
            type: String,
            default: 'Отмена',
        },
        cancelButtonClass: {
            type: String,
            default: 'small text second mr-3',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isConfirm: {
            type: Boolean,
            default: false,
        },
        confirmMessage: {
            type: String,
            default: 'Confirm message',
        },
        confirmMessageBold: {
            type: String,
            default: null,
        },
        withoutFooter: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        additionalButton: {
            type: Boolean,
            default: false,
        },
        additionalButtonText: {
            type: String,
            default: 'additional button text',
        },
        confirmDisabled: {
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
            default: null,
        },
    },
    components: {
        'the-button': TheButton,
    },
    emits: ['cancel', 'additional-action', 'confirm'],
    setup(_, { emit }) {
        const emitCancel = () => {
            emit('cancel')
        }

        const emitConfirm = () => {
            emit('confirm')
        }

        const emitAdditionalAction = () => {
            emit('additional-action')
        }

        return { emitCancel, emitConfirm, emitAdditionalAction }
    },
})
